
export const getSecuredFileUrl = (filePath) => {
    let url = new URL(`${process.env.REACT_APP_BASE_API_URL}/${process.env.REACT_APP_VERSION_V1}/${filePath}`)
    console.log(url);
    return url?.href?.toString()
}

export const getFilePath = (name, project_id, item_id) => {
    let BaseUrl = new URL(`${process.env.REACT_APP_BASE_API_URL}/${process.env.REACT_APP_VERSION_V1}/file/vendor`)
    return (`${BaseUrl}/${project_id}/${item_id}/${name}`)
}
export const getFilePathForView = (name, project_id, item_id) => {
    let BaseUrl = new URL(`${process.env.REACT_APP_BASE_API_URL}/${process.env.REACT_APP_VERSION_V1}/file/vendor/read`)
    return (`${BaseUrl}/${project_id}/${item_id}/${name}`)
}


export const isShowable = (file) => {
    const extention = file.split('.').pop()

    switch (extention) {
        case "pdf":
            return true
        case "jpg":
            return true
        case "png":
            return true
        case "jpeg":
            return true
        case "svg":
            return true
        default:
            return false
    }
}



export const getPreviewUrl = (file, project_id, item_id) => {
    const extention = file.split('.').pop()
    switch (extention) {
        case "svg":
            return getFilePath(file, project_id, item_id)
        case "png":
            return getFilePathForView(file, project_id, item_id)
        case "jpg":
            return getFilePathForView(file, project_id, item_id)
        case "jpeg":
            return getFilePathForView(file, project_id, item_id)
        case "xlsx":
            return "/icons/filetypes/xlsx.svg"
        case "csv":
            return "/icons/filetypes/xlsx.svg"
        case "ai":
            return "/icons/filetypes/ai.svg"
        case "pdf":
            return "/icons/filetypes/pdf.svg"
        default:
            return "/icons/filetypes/file.svg"
    }
}

export const getPreview = (file) => {
    if (/image\/[a-z+.-]+/.test(file.type)) {
        return file.preview
    }
    switch (file.type) {
        case "application/pdf":
            return "/icons/filetypes/pdf.svg"
        default:
            return "/icons/filetypes/file.svg"
    }
}